import React from 'react';
import Input from '../../../../../Utility/FormElements/Input';
import TextareaAutosize from 'react-textarea-autosize';
import Select from '../../../../../Utility/FormElements/Select';
// import { McpTransport } from '../../../../../../Hooks/useMcpConfig';
import useGlobals from '../../../../../../Hooks/useGlobals';

type Props = {
    title: string;
    description: string;
    serverUrl: string;
    transport: any;
    timeout: number;
    errors: Record<string, string>;
    onChange: (
        updates: Partial<{
            title: string;
            description: string;
            serverUrl: string;
            transport: any;
            timeout: number;
        }>,
    ) => void;
};

const BasicInformationSection: React.FC<Props> = ({
    title,
    description,
    serverUrl,
    transport,
    timeout,
    errors,
    onChange,
}) => {
    const { i18n } = useGlobals();
    return (
        <div className="space-y-4">
            <div className="my-4">
                <h4>{i18n.translate({ id: 'form.basicInfo.title', sourceName: 'MCP' })}</h4>
            </div>

            <div>
                <label className="block text-sm font-medium text-layout-textcolor mb-2">
                    {i18n.translate({ id: 'form.title.label', sourceName: 'MCP' })} *
                </label>
                <Input
                    value={title}
                    onChange={(value) => onChange({ title: value })}
                    placeholder={i18n.translate({ id: 'form.title.placeholder', sourceName: 'MCP' })}
                />
                {errors.title && <span className="text-red-500 text-xs mt-1">{errors.title}</span>}
            </div>

            <div>
                <label className="block text-sm font-medium text-layout-textcolor mb-2">
                    {i18n.translate({ id: 'form.description.label', sourceName: 'MCP' })}
                </label>
                <TextareaAutosize
                    className="w-full focus:border-primary ring-none outline-none p-3 border-2 border-layout-borderColor rounded-lg bg-input-backgroundColor text-layout-textcolor"
                    value={description}
                    onChange={(e) => onChange({ description: e.target.value })}
                    placeholder={i18n.translate({ id: 'form.description.placeholder', sourceName: 'MCP' })}
                    minRows={2}
                    maxRows={4}
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-layout-textcolor mb-2">
                    {i18n.translate({ id: 'form.serverUrl.label', sourceName: 'MCP' })} *
                </label>
                <Input
                    value={serverUrl}
                    onChange={(value) => onChange({ serverUrl: value })}
                    placeholder={'https://mcp.example.com/api/mcp'}
                />
                {errors.serverUrl && <span className="text-red-500 text-xs mt-1">{errors.serverUrl}</span>}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-layout-textcolor mb-2">
                        {i18n.translate({ id: 'form.transport.label', sourceName: 'MCP' })}
                    </label>
                    <Select value={transport} onChange={(value) => onChange({ transport: value as any })}>
                        <option value="http">{i18n.translate({ id: 'form.transport.http', sourceName: 'MCP' })}</option>
                    </Select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-layout-textcolor mb-2">
                        {i18n.translate({ id: 'form.timeout.label', sourceName: 'MCP' })}
                    </label>
                    <Input
                        inputType="number"
                        value={timeout.toString()}
                        onChange={(value) => onChange({ timeout: parseInt(value) || 30 })}
                        placeholder={i18n.translate({ id: 'form.timeout.placeholder', sourceName: 'MCP' }) || '30'}
                    />
                </div>
            </div>
        </div>
    );
};

export default BasicInformationSection;
